import { Injectable, OnDestroy } from '@angular/core';
import { Observable, BehaviorSubject, of, Subscription } from 'rxjs';
import { map, catchError, switchMap, finalize, tap } from 'rxjs/operators';
import { UserModel } from '../_models/user.model';
import { AuthModel } from '../_models/auth.model';
import { AuthHTTPService } from './auth-http';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class AuthService implements OnDestroy {

  isSessionExpired$: BehaviorSubject<boolean> = new BehaviorSubject(false)


  // private fields
  private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
  private authLocalStorageToken = `${environment.appVersion}-${environment.USERDATA_KEY}`;

  // public fields
  currentUser$: Observable<UserModel>;
  isLoading$: Observable<boolean>;
  currentUserSubject: BehaviorSubject<UserModel>;
  isLoadingSubject: BehaviorSubject<boolean>;


  get currentUserValue(): UserModel {
    return this.currentUserSubject.value;
  }

  set currentUserValue(user: UserModel) {
    this.currentUserSubject.next(user);
  }

  constructor(
    private authHttpService: AuthHTTPService,
    private router: Router,
    private http: HttpClient
  ) {
    this.isLoadingSubject = new BehaviorSubject<boolean>(false);
    this.currentUserSubject = new BehaviorSubject<UserModel>(undefined);
    this.currentUser$ = this.currentUserSubject.asObservable();
    this.isLoading$ = this.isLoadingSubject.asObservable();
    // const subscr = this.getUserProfile().subscribe();
    // this.unsubscribe.push(subscr);
  }

  // public methods

  logout() {
    localStorage.removeItem(this.authLocalStorageToken);
    localStorage.removeItem('exspireIntime');
    localStorage.removeItem('hw-verify');
    this.router.navigate(['/auth/login'], {
      queryParams: {},
    });
  }



  loginWith(platform, guestToken): Observable<any> {
    this.isLoadingSubject.next(true);
    return this.authHttpService.getAccessToken(guestToken).pipe(
      map(res => {
        const result = this.setAuthFromLocalStorage({ codeToken: res?.token, guestToken, platform });
        return result;
      }),
      switchMap(() => this.getUserLoginPage()),
      catchError((err) => {
        console.error('err', err);
        return of(undefined);
      }),
      finalize(() => this.isLoadingSubject.next(false))
    );
  }

  getUserLoginPage(): Observable<any> {
    const auth = this.getAuthFromLocalStorage();
    if (!auth || !auth.codeToken) {
      return of(undefined);
    }
    this.isLoadingSubject.next(true);
    return this.authHttpService.loginWith(auth).pipe(
      catchError((err) => {
        console.error('err', err);
        return of(undefined);
      }),
      finalize(() => this.isLoadingSubject.next(false))
    );
  }

  verifyLoginWithUser(code) {
    const auth = this.getAuthFromLocalStorage();
    if (!auth || !auth.codeToken) {
      return of(undefined);
    }
    this.isLoadingSubject.next(true);
    return this.authHttpService.verifyLoginWith(code, auth).pipe(
      map((user: { item: UserModel, access_token: string }) => {
        if (user) {
          this.currentUserSubject = new BehaviorSubject<UserModel>(user.item);
          this.setAuthFromLocalStorage({ ...auth, accessToken: user.access_token });
        } else {
          this.logout();
        }
        return user;
      }),
      finalize(() => this.isLoadingSubject.next(false))
    );
  }
  
  regularLogin(email,password,recaptcha,isLoginMailService) {
    const body = new FormData();
    body.append('email', email);
    body.append('password', password);
    body.append('g-recaptcha-response', recaptcha);
    this.isLoadingSubject.next(true);
    return this.authHttpService.login(body,isLoginMailService).pipe(
      map((res) => {
        if (res?.item) {
          this.currentUserSubject = new BehaviorSubject<UserModel>(res.item);
          this.setAuthFromLocalStorage(
            {"codeToken":"xx","platform":"web","accessToken": res.access_token });
        } else {
          this.logout();
        }
        return res;
      }),
      finalize(() => this.isLoadingSubject.next(false))
    );
  }

  getUserProfile() {
    const auth = this.getAuthFromLocalStorage();
    if (!auth || !auth.accessToken) {
      return of(undefined);
    }

    this.isLoadingSubject.next(true);
    return this.authHttpService.getUserProfile(auth.accessToken).pipe(
      map((user: UserModel) => {
        if (user) {
          this.currentUserSubject = new BehaviorSubject<UserModel>(user);
        } else {
          this.logout();
        }
        return user;
      }),
      finalize(() => this.isLoadingSubject.next(false))
    );
  }
  // private methods
  private setAuthFromLocalStorage(auth: AuthModel): boolean {
    // store auth accessToken/refreshToken/epiresIn in local storage to keep user logged in between page refreshes
    if (auth && auth.codeToken) {
      localStorage.setItem(this.authLocalStorageToken, JSON.stringify(auth));
      return true;
    }
    return false;
  }

  public getAuthFromLocalStorage(): AuthModel {
    try {
      const authData = JSON.parse(
        localStorage.getItem(this.authLocalStorageToken)
      );
      return authData;
    } catch (error) {
      console.error(error);
      return undefined;
    }
  }

  // public methods
  // To use when refresh token
  public changeUserAuthData(auth: AuthModel): boolean {
    // store auth accessToken/refreshToken/epiresIn in local storage to keep user logged in between page refreshes
    if (auth && auth.codeToken) {
      localStorage.setItem(this.authLocalStorageToken, JSON.stringify(auth));
      return true;
    }
    return false;
  }

  // Hwasabah 

  getHwasabahUserInfo(params?) {
    const auth = this.getAuthFromLocalStorage();
    if (!auth || !auth.accessToken) {
      return of(undefined);
    }

    const httpHeaders = new HttpHeaders({
      Authorization: `Bearer ${auth.accessToken}`,
    });

    const ENDPOINT = `admin/area/hawsabah/auth/info`;
    return this.http.get(`${environment.apiUrl}/${ENDPOINT}`,{
      params
    });
    // return of({"code":200,"message":"api.success_operation","data":null})
    // return of({"code":200,"message":"api.success_operation","data":{"userId":"5e1d02f6-afef-4001-97a1-1459178dc421","username":"\u0639\u0628\u062f\u0627\u0644\u0631\u062d\u0645\u0646 \u0643\u0628\u0648\u0647\u0627","details":{"Email":"a.kabouha@oursms.ws","MobilePhone":"590388975","Role":"Provider User","ProviderId":"94902203-f5f2-4840-9359-f3348c01ed38","Provider":"\u0634\u0631\u0643\u0629 \u0631\u0648\u0627\u0632\u0646 \u0627\u0644\u062f\u0648\u0644\u064a\u0629","OperatorId":null,"Operator":null,"ChangePasswordRequired":"False"}}})
  }

  loginHwsabah(params) {
    const auth = this.getAuthFromLocalStorage();
    if (!auth || !auth.accessToken) {
      return of(undefined);
    }
    const httpHeaders = new HttpHeaders({
      Authorization: `Bearer ${auth.accessToken}`,
    });

    const ENDPOINT = `admin/area/hawsabah/auth`;
    return this.http.get(`${environment.apiUrl}/${ENDPOINT}`,{
      params
    });
    // return of({"code":200,"message":"api.success_operation","items":{"data":"CfDJ8EXKgmZtXBhDrpw0JSA7ZCKUb5b-_EH7nyigMp7hv5Yil6jHjBFmMUitSgpqNYomPn-0V6LT6iZd6-7Ho2hk0OFDzwVY1r2-osn8CdxFfS0n4yqAStR92DCi97_-9zkxYXsZccmfwxbhiv2_exfs4Vlaz0quwhX9_SRWodG2sRGPTijOmLz1aUjHtfO2AjV3heNDe53irN6Zni72kbmZ76oqtqSyXkAms6ZOPf0JEwTEXEyVBvbfYEPqJwnW3vzf1KuMtQjtHvTUjA0CqOrL48OwYSJ6xhLQeVRC44BapBbI2rQ2wXUQ0YYbtSVoW6mEr-S4jLfljSDYadcTTRSFE3gsY2WB4_TVc5KumG5fEP0FrjpnzQ1qgm0P5ImckwDFCWFcZB7Z2Mz5XwGqh544nYPnkW2VUHgj7DcZNYXZkW7R5mxCXqnPGk3r3F082IUxM17JZfZRGmQkK-H9pR6boOQ16Burz219NwSE0OJPTEekfkZ6ygSj5llBkh5LfsilUs2V_VSdOYYWsz7pcuCHgarVTcOJsjq1VXnOP4NQgJ2xTCwUdkDp-yJPMJ4KxLfT5Y0f_a0wh-9osDZWTlEII6QUOHcg-g1peRzrmQAP264XL0OZhoMLhq-5amWM7oKUxUwbV3cTnlIDk_1nBxK_yXL6hQy2KWPFRmrKrEVM4K6cr4c38tqUUCgJ0hpwlI6DR6twbxprOde9XceRXknZOv6xgN76LjoEtx8y-8xSlTkG7v7UZPk8eHV6ZhQcRj_t0nlbqI-L8LWmCkYT4RSL8DOfZwmbwVT6yO6wMWdWld8gsGrgtLaWI4mjFHcUN15MXKvN7TKRslJE1e9VGjGH0wQeDYI8Wqd7KpZ2LSXTZUGh8GkCul1qPKynGCV8YV3HjyFMh1SEwqx5I8u1g0hEhlFnyw7ylGltb-wLbtuaKvoC0em-Q61ycQLCc0a9g9wEQhwVZm_pvLY0W-et9fcjGISc8B3tgjvFYT0Q_oqIRza892FZEGLnFXcPGLG61pqCRIlenP4uK7WH1WlfzlOC1f0nlOwazai7RNm-t6LGLHdkcWZgx3Lr71IiRFGFHirAzLMPBTrLromwn1fchshN0ICM0mEYbaADy_uupcyV7pgstV6P2x1ebGjIThY2zkz45w66phso4SmrcZ-fYnREc4xBg5yQKgAx2EBRLYbdnlUL0ov7kXoe73MHmTK8KNmVLNbwa2dPNrSQETFUIN324K7F3_JAbSRuFW-TjfrBcXBajChPCsMN6Rw0hus8DRE44dKF8tmYzZhEpnoNe0Rgqwu0capO-gW9N264uspAI96OJAFhhILopdV-qe1cpUT7OkhWKFoENf45NEYJbhUdZczPBFLOe5YKlbgx0ow1x08ahTwZRwELG9j-QN_y7srKRM5xtT6Tu4-WJC0jDw6uIfp-AFszNlZIPnOB_9X6thn6","isSuccess":true,"errorMessage":null,"expiresAt":"CfDJ8EXKgmZtXBhDrpw0JSA7ZCKi9QFbdvv72RHhPtnoDa6QdQSg0pgl1oBhcQ_33ImG0C6kQ1H-ugWIph4qSFp0A__GRYcSvZ5gnNqbwQ50ERash2rKc8JAhLphEh6aK2fuQ2O9MtEfGKz_rVmj0qUeOes","duration":60,"isOTPEnabled":true}})
  }

  resendCodeToMobile(body) {
    const auth = this.getAuthFromLocalStorage();
    if (!auth || !auth.accessToken) {
      return of(undefined);
    }

    const ENDPOINT = `admin/area/hawsabah/auth/resend-otp`;
    return this.http.post(`${environment.apiUrl}/${ENDPOINT}`, body);
  }

  verifyCode(body) {
    const auth = this.getAuthFromLocalStorage();
    if (!auth || !auth.accessToken) {
      return of(undefined);
    }

    const ENDPOINT = `admin/area/hawsabah/auth/otp`;
    return this.http.post(`${environment.apiUrl}/${ENDPOINT}`, body);

  }
  // =====================================

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }

  refreshToke() {
    const ENDPOINT = `admin/area/profile/refresh`;
    return this.http.post(`${environment.apiUrl}/${ENDPOINT}`, {});
  }
}
